var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.1875 0.9375C7.1875 0.417969 6.76953 0 6.25 0C5.73047 0 5.3125 0.417969 5.3125 0.9375V2.5H3.75C2.37109 2.5 1.25 3.62109 1.25 5V5.625V7.5V17.5C1.25 18.8789 2.37109 20 3.75 20H16.25C17.6289 20 18.75 18.8789 18.75 17.5V7.5V5.625V5C18.75 3.62109 17.6289 2.5 16.25 2.5H14.6875V0.9375C14.6875 0.417969 14.2695 0 13.75 0C13.2305 0 12.8125 0.417969 12.8125 0.9375V2.5H7.1875V0.9375ZM3.125 7.5H16.875V17.5C16.875 17.8438 16.5938 18.125 16.25 18.125H3.75C3.40625 18.125 3.125 17.8438 3.125 17.5V7.5Z",
    fill: "#212737"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.1d7ebc5a162336c71a1b78fb55d9a08a.svg";
export { ForwardRef as ReactComponent };